import { configureStore } from "@reduxjs/toolkit"
import userReducer from "./user/userSlice"
import navigatorReducer from "./navigator/navigatorSlice"
export default configureStore({
  reducer: {
    user: userReducer,
    navigator: navigatorReducer
  },
})
